/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs */

const en_guide_json_vs_yaml_xml_s5_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>YAML</strong> for: Configuration files, CI/CD pipelines, Kubernetes manifests, Docker Compose files`)
};

const ko_guide_json_vs_yaml_xml_s5_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>YAML</strong> 사용: 설정 파일, CI/CD 파이프라인, Kubernetes 매니페스트, Docker Compose 파일`)
};

const ja_guide_json_vs_yaml_xml_s5_li2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>YAML</strong>の使用場面：設定ファイル、CI/CDパイプライン、Kubernetesマニフェスト、Docker Composeファイル`)
};

/**
* | output |
* | --- |
* | "Use <strong>YAML</strong> for: Configuration files, CI/CD pipelines, Kubernetes manifests, Docker Compose files" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s5_li2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S5_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s5_li2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s5_li2(inputs)
	return ja_guide_json_vs_yaml_xml_s5_li2(inputs)
});